/**
 * RO-7-04 / #44334 — shared Operation schemas for agent-goals / goal_list twin.
 *
 * agentGoals.list is the agentic-scoped HTTP projection of goal_list.
 * Shared filter atoms keep the kind/status enums aligned.
 */
import { z } from "zod";
export const GOAL_STATUS = [
    "active",
    "paused",
    "done",
    "abandoned",
];
export const goalStatusSchema = z.enum(GOAL_STATUS);
export const GOAL_KINDS = ["agentic", "strategic"];
export const goalKindSchema = z.enum(GOAL_KINDS);
/**
 * Filters shared in spirit between goal_list (MCP) and agentGoals.list (HTTP).
 * HTTP currently only exposes projectIds (agentic-scoped home); MCP exposes
 * status/role/kind/id. The kind atom is the important shared piece for the
 * twin inventory probe (mcpArgs: { kind: "agentic" }).
 */
export const agentGoalsListFiltersSchema = z.object({
    projectIds: z.string().optional(),
    status: goalStatusSchema.optional(),
    role: z.string().optional(),
    kind: goalKindSchema.optional(),
});
